import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Checkbox, Row, Col, InputNumber } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

import '../App.css';
import { injectIntl, defineMessages, FormattedMessage  } from 'react-intl';

const messages = defineMessages({
    credntials: {
      id: 'Credentials',
    },  
    password_warning: {
      id: 'Password_empty',
    },
    username_warning: {
        id: 'Username_empty',
      }, 
      server: {
        id: 'SMTP.server_name',
      },  
      server_warning: {
        id: 'SMTP.server_name_empty',
      },  
      schedule: {
        id: 'SMTP.schedule_time',
      },  
      sender: {
        id: 'SMTP.sender_name',
      },  
      no_use: {
        id: 'SMTP.do_not_use',
      },  
});

const layout = {
    labelCol: {
        offset: 1,
        span: 3,
    },
    wrapperCol: {       
        offset: 0,
        span: 8,
    },
  };
  const tailLayout = {
    wrapperCol: {
      offset: 4,
      span: 6,
    },
  };
  
class SMTServerSettings extends Component {
    constructor(props) 
    {
      super(props);
      this.state = {
        enableReports: this.props.smtp_settings.SendReportsViaEmail !== undefined ? this.props.smtp_settings.SendReportsViaEmail : false,
        enableTest: false,
      };
    }

    onFieldsChange(changedFields, allFields)
    {
        var enableTestButton = false;

        if (changedFields.length > 0)
        {
          var do_not_send = allFields[5].value;
          this.smtp_server = allFields[0].value;
          this.username = allFields[1].value;
          this.password = allFields[2].value;

          if (this.username !== undefined && this.password !== undefined && this.smtp_server !== undefined)
          {
            enableTestButton = this.username.length > 0 && this.password.length > 0 && this.smtp_server.length > 0
          }
          
          this.setState({enableTest: enableTestButton, enableReports: !do_not_send});
        }
    }
    
    onFinish(values) 
    {
      const smtp_settings = {
        "SmtpMailFrom":values["sender"],
        "SmtpServer":values["server"],
        "SmtpLoginUser":values["username"],
        "SmtpLoginPassword":values["password"],
        "DailyReportsHour": values["schedule"],
        "SendReportsViaEmail": values["do_not_send"] === true ? 0 : 1,
      }

        this.props.submit(smtp_settings);
    };
    
    onFinishFailed(errorInfo) 
    {
 
    };

    testSMTP(e)
    {
      const test_smtp_settings = {
        "SmtpServer":this.smtp_server,
        "SmtpLoginUser": this.username,
        "SmtpLoginPassword":this.password,
      }

      this.props.test(test_smtp_settings);
    };
  
    render() 
    {
      return (
        <div style={{align:"left", textAlign: "left"}}>
        <br/>
        <Form
        {...layout}
        name="basic"
        initialValues={{
            server: this.props.smtp_settings.SmtpServer,
            username: this.props.smtp_settings.SmtpLoginUser,
            sender: this.props.smtp_settings.SmtpMailFrom,
            schedule: this.props.smtp_settings.DailyReportsHour,
            do_not_send: !this.props.smtp_settings.SendReportsViaEmail
        }}
        onFinish={(values) => this.onFinish(values)}
        onFinishFailed={(errorInfo) => this.onFinishFailed(errorInfo)}
        onFieldsChange={(changedFields, allFields) => this.onFieldsChange(changedFields, allFields)}
        >
            <Form.Item
                labelAlign="right"
                label={this.props.intl.formatMessage(messages.server)}
                name="server"
                rules={[
                {
                    required: this.state.enableReports,
                    message: this.props.intl.formatMessage(messages.server_warning),
                },
                ]}
            >
                <Input disabled={!this.state.enableReports}/>
            </Form.Item>

            <Form.Item label={this.props.intl.formatMessage(messages.credntials)}>
              <Row gutter={8}>
              <Col span={8}>
                <Form.Item
                    name="username"
                    noStyle
                    rules={[
                      {
                        required: this.state.enableReports,
                        message: this.props.intl.formatMessage(messages.username_warning),
                      },
                    ]}
                  >
                    <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" disabled={!this.state.enableReports}/>
                  </Form.Item>
                </Col>
                <Col span={8}>
                <Form.Item
                    name="password"
                    noStyle
                    rules={[
                      {
                        required: this.state.enableReports,
                        message: this.props.intl.formatMessage(messages.password_warning),
                      },
                    ]}
                  >
                    <Input prefix={<LockOutlined className="site-form-item-icon"/>} placeholder="Password" type="password" disabled={!this.state.enableReports}/>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Button type="primary" disabled={!this.state.enableTest} onClick={(e) => this.testSMTP(e)}>Test</Button>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item 
              label={this.props.intl.formatMessage(messages.schedule)} 
              name="schedule" 
              >
                <InputNumber min={0} max={23} disabled={!this.state.enableReports}/>
            </Form.Item>

            <Form.Item
                labelAlign="right"
                label={this.props.intl.formatMessage(messages.sender)}
                name="sender"
            >
              <Input disabled={!this.state.enableReports}/>
            </Form.Item>

            <Form.Item {...tailLayout} name="do_not_send" valuePropName="checked">
                <Checkbox><FormattedMessage id="SMTP.do_not_use"/></Checkbox>
            </Form.Item>

            <Form.Item {...tailLayout} labelAlign="right">
                <Button type="primary" htmlType="submit">
                  <FormattedMessage id="Submit"/>
                </Button>
            </Form.Item>
        </Form>      
        </div>
    );
  }
}

const propTypes = {
    smtp_settings: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired,
    test: PropTypes.func.isRequired
  };
  SMTServerSettings.propTypes = propTypes;

  export default injectIntl(SMTServerSettings, {
    withRef: true,
  });
  